export const YANDEX_MAPS_API_KEY = 'fbfce4f4-024d-40ec-b538-95a72bfa73d6';